import { notification } from 'antd';
import { saveAs } from 'file-saver';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../App.context';
import { ApiContext } from '../networking/Api.context';

export default function useBookingExportHook() {
  const { appActions } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    loading: false,
  });

  useEffect(() => {
    appActions.setExportingInProgress(state.loading);
  }, [, state.loading]);

  const checkinExportActions = {
    export: (hotel, dateFrom, dateTo) => {
      updateState({ loading: true });
      API.bookingsExportRequest({
        hotel,
        dateFrom,
        dateTo,
        lang: appActions.getSelectedLanguage().id,
      })
        .then(data => {
          notification.success({
            message: 'Exportación de checkins completada!',
          });
          saveAs(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
            'bookings_export.xlsx'
          );
        })
        .catch(error => {
          console.warn(error);
        })
        .finally(() => {
          updateState({ loading: false });
        });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { bookingExportActions: checkinExportActions };
}
